import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { observer } from "mobx-react";  
import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { CheckOutStore } from "../../shared/store";
import { UpsertCheckoutActiveStep } from "../../shared/enums";

interface IProps {
  checkoutStore: CheckOutStore;
  children: React.ReactElement;
  currentRoute: string;
}

const CheckOutProtectedRoutes: React.FC<IProps> = ({
  children,
  currentRoute,
  checkoutStore,
}) => {
  let isValid = false;
  const params = useParams();
  const checkOutId = () => {
    const split = ((params && params["*"]) || "").split("/");
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return null;
  };

  switch (checkoutStore.activeStep) {
    case UpsertCheckoutActiveStep.Detail:
      isValid = currentRoute === "detail";
      break;
    case UpsertCheckoutActiveStep.Sell:
      isValid = currentRoute === "sell";
      break;
    case UpsertCheckoutActiveStep.Pay:
      isValid = currentRoute === "pay";
      break;
    case UpsertCheckoutActiveStep.AfterPay:
      isValid = currentRoute === "afterpay";
      break;
    case UpsertCheckoutActiveStep.Options:
      isValid = currentRoute === "options";
      break;
  }

  const queryParam: string = checkOutId() ? `/${checkOutId()}` : "";

  return isValid ? (
    children
  ) : (
    <Navigate to={`/app/checkout/detail${queryParam}`} />
  );
};

export default observer(CheckOutProtectedRoutes);
